import { cloneElement, useState } from 'react'
import data from '@emoji-mart/data'
import EmojiMartPicker from '@emoji-mart/react'

export const EmojiPicker = ({ children, onOpen, onSelect, ...rest }) => {
  const [isOpen, setIsOpen] = useState(false)

  const togglePicker = (e) => {
    e.stopPropagation()

    if (isOpen) {
      setIsOpen(false)
    } else {
      setIsOpen(true)

      if (onOpen) {
        onOpen()
      }
    }
  }

  const handleEmojiSelect = (emoji, event) => {
    if (onSelect) {
      onSelect(emoji, event)
    }

    setIsOpen(false)
  }

  return (
    <span className="relative inline-block">
      {cloneElement(children, { onClick: togglePicker })}
      {isOpen && (
        <span className="absolute bottom-15 left-0 z-1">
          <EmojiMartPicker
            color="#2B6CB0"
            data={data}
            onClickOutside={() => setIsOpen(false)}
            onEmojiSelect={handleEmojiSelect}
            previewPosition="none"
            set="native"
            skinTonePosition="none"
            theme="light"
            {...rest}
          />
        </span>
      )}
    </span>
  )
}
